// Mock data store - persisted to localStorage

const DEFAULT_DATA = {
  users: [
    {
      id: 'u1',
      username: 'admin',
      password: 'admin123',
      email: 'admin@kamig.io',
      firstName: 'Alex',
      lastName: 'Morgan',
      role: 'admin',
      avatar: null,
      license: { plan: 'Enterprise', status: 'active', expiresAt: '2027-01-15' },
    },
    {
      id: 'u100',
      username: 'kalcheva',
      password: 'admin123',
      email: 'kalcheva@example.com',
      firstName: 'Kameliya',
      lastName: 'Kalcheva',
      role: 'admin',
      avatar: null,
      license: { plan: 'Enterprise', status: 'active', expiresAt: '2026-12-31' },
    },
    {
      id: 'u2',
      username: 'jane',
      password: 'jane123',
      email: 'jane@kamig.io',
      firstName: 'Jane',
      lastName: 'Smith',
      role: 'operator',
      avatar: null,
      license: { plan: 'Enterprise', status: 'active', expiresAt: '2027-01-15' },
    },
  ],

  team: [
    { id: 't1', userId: 'u1', name: 'Alex Morgan', email: 'admin@kamig.io', role: 'admin', status: 'active', joinedAt: '2025-06-01' },
    { id: 't100', userId: 'u100', name: 'Примерна фирма ООД', email: 'kalcheva@example.com', role: 'admin', status: 'active', joinedAt: '2026-06-01' },
    { id: 't2', userId: 'u2', name: 'Jane Smith', email: 'jane@kamig.io', role: 'operator', status: 'active', joinedAt: '2025-07-12' },
    { id: 't3', userId: null, name: 'Bob Lee', email: 'bob@kamig.io', role: 'viewer', status: 'pending', joinedAt: '2026-03-20' },
  ],

  idpConfigs: [
    {
      id: 'idp1',
      name: 'Okta Production',
      type: 'source',
      provider: 'Okta',
      url: 'https://mycompany.okta.com',
      apiKey: 'sk-okta-xxxx-1234',
      createdAt: '2026-01-10',
      status: 'active',
    },
    {
      id: 'idp2',
      name: 'Azure AD',
      type: 'destination',
      provider: 'Azure AD',
      url: 'https://login.microsoftonline.com/tenant-id',
      apiKey: 'az-key-xxxx-5678',
      createdAt: '2026-01-11',
      status: 'active',
    },
    {
      id: 'idp3',
      name: 'Auth0 Staging',
      type: 'source',
      provider: 'Auth0',
      url: 'https://staging.auth0.com',
      apiKey: 'a0-key-xxxx-9012',
      createdAt: '2026-02-05',
      status: 'active',
    },
    {
      id: 'idp4',
      name: 'Ping Identity',
      type: 'destination',
      provider: 'PingIdentity',
      url: 'https://sso.pingidentity.com/org123',
      apiKey: 'pi-key-xxxx-3456',
      createdAt: '2026-02-20',
      status: 'inactive',
    },
  ],

  policies: [
    {
      id: 'pol1',
      name: 'Full User Migration - Okta to Azure',
      sourceIdpId: 'idp1',
      destIdpId: 'idp2',
      userFilter: 'department=Engineering',
      appsFilter: 'type=SAML',
      syncFrequency: 'daily',
      status: 'active',
      createdAt: '2026-02-01',
    },
    {
      id: 'pol2',
      name: 'Auth0 to Ping - Admins Only',
      sourceIdpId: 'idp3',
      destIdpId: 'idp4',
      userFilter: 'role=admin',
      appsFilter: 'all',
      syncFrequency: 'weekly',
      status: 'paused',
      createdAt: '2026-03-01',
    },
  ],

  migrationStatus: [
    { id: 'ms1', policyId: 'pol1', entityType: 'user', entityName: 'john.doe@company.com', status: 'completed', migratedAt: '2026-03-15 10:30', details: 'User and 3 app assignments migrated' },
    { id: 'ms2', policyId: 'pol1', entityType: 'user', entityName: 'sarah.connor@company.com', status: 'completed', migratedAt: '2026-03-15 10:31', details: 'User and 5 app assignments migrated' },
    { id: 'ms3', policyId: 'pol1', entityType: 'application', entityName: 'Salesforce SSO', status: 'completed', migratedAt: '2026-03-15 10:32', details: 'SAML config migrated successfully' },
    { id: 'ms4', policyId: 'pol1', entityType: 'user', entityName: 'mike.ross@company.com', status: 'failed', migratedAt: '2026-03-15 10:33', details: 'Conflict: user already exists in destination' },
    { id: 'ms5', policyId: 'pol1', entityType: 'application', entityName: 'Jira Cloud', status: 'in_progress', migratedAt: null, details: 'OIDC config migration in progress' },
    { id: 'ms6', policyId: 'pol2', entityType: 'user', entityName: 'admin@staging.com', status: 'pending', migratedAt: null, details: 'Queued for next sync cycle' },
    { id: 'ms7', policyId: 'pol1', entityType: 'user', entityName: 'lisa.chen@company.com', status: 'completed', migratedAt: '2026-03-15 10:35', details: 'User and 2 app assignments migrated' },
    { id: 'ms8', policyId: 'pol1', entityType: 'application', entityName: 'Slack Enterprise', status: 'completed', migratedAt: '2026-03-15 10:36', details: 'SAML config migrated successfully' },
  ],

  auditLogs: [
    { id: 'al1', userId: 'u1', userName: 'Alex Morgan', action: 'Created IdP config "Okta Production"', timestamp: '2026-01-10 09:00', category: 'config' },
    { id: 'al2', userId: 'u1', userName: 'Alex Morgan', action: 'Created IdP config "Azure AD"', timestamp: '2026-01-11 14:22', category: 'config' },
    { id: 'al3', userId: 'u2', userName: 'Jane Smith', action: 'Created policy "Full User Migration - Okta to Azure"', timestamp: '2026-02-01 11:00', category: 'policy' },
    { id: 'al4', userId: 'u1', userName: 'Alex Morgan', action: 'Created IdP config "Auth0 Staging"', timestamp: '2026-02-05 08:15', category: 'config' },
    { id: 'al5', userId: 'u1', userName: 'Alex Morgan', action: 'Created IdP config "Ping Identity"', timestamp: '2026-02-20 16:45', category: 'config' },
    { id: 'al6', userId: 'u2', userName: 'Jane Smith', action: 'Created policy "Auth0 to Ping - Admins Only"', timestamp: '2026-03-01 10:30', category: 'policy' },
    { id: 'al7', userId: 'u1', userName: 'Alex Morgan', action: 'Started migration for policy "Full User Migration"', timestamp: '2026-03-15 10:28', category: 'migration' },
    { id: 'al8', userId: 'u2', userName: 'Jane Smith', action: 'Invited Bob Lee (bob@kamig.io) as viewer', timestamp: '2026-03-20 13:00', category: 'team' },
    { id: 'al9', userId: 'u1', userName: 'Alex Morgan', action: 'Updated profile information', timestamp: '2026-03-25 09:12', category: 'profile' },
    { id: 'al10', userId: 'u1', userName: 'Alex Morgan', action: 'Paused policy "Auth0 to Ping - Admins Only"', timestamp: '2026-03-28 11:45', category: 'policy' },
  ],
};

function loadData() {
  const stored = localStorage.getItem('kamig_data');
  if (stored) {
    return JSON.parse(stored);
  }
  localStorage.setItem('kamig_data', JSON.stringify(DEFAULT_DATA));
  return { ...DEFAULT_DATA };
}

function saveData(data) {
  localStorage.setItem('kamig_data', JSON.stringify(data));
}

export function resetData() {
  localStorage.removeItem('kamig_data');
  return loadData();
}

export { loadData, saveData };
